import React from 'react';

import {defineMessages, useIntl} from 'react-intl';

type IntervalConfig = {
  interval: string;
  interval_count?: number | null;
};

const messages = defineMessages({
  planIntervalDesc: {
    id: 'conversations_ui.subscriptions.plan.interval.description',
    description: `The very short description of how often a plan is billed.`,
    defaultMessage: `{intervalCount, plural,
    one   {{intervalUnit, select,
      day   {Daily}
      week  {Weekly}
      month {Monthly}
      year  {Yearly}
      other {}
    }}
    other {{intervalUnit, select,
      day   {Every {formattedIntervalCount} days}
      week  {Every {formattedIntervalCount} weeks}
      month  {Every {formattedIntervalCount} months}
      year  {Every {formattedIntervalCount} years}
      other {}
    }}
  }`,
  },
});

export function useFormatInterval() {
  const intl = useIntl();

  return React.useCallback(
    (config: IntervalConfig): string => {
      return intl.formatMessage(messages.planIntervalDesc, {
        intervalCount: config.interval_count ?? 1,
        formattedIntervalCount: intl.formatNumber(config.interval_count ?? 1),
        intervalUnit: config.interval,
      });
    },
    [intl],
  );
}
